import { render, staticRenderFns } from "./manCard_wrs.vue?vue&type=template&id=6f7c9a27&scoped=true&"
import script from "./manCard_wrs.vue?vue&type=script&lang=ts&"
export * from "./manCard_wrs.vue?vue&type=script&lang=ts&"
import style0 from "./manCard_wrs.vue?vue&type=style&index=0&id=6f7c9a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c9a27",
  null
  
)

export default component.exports